
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cms/journal/article/[editoSlug]",
      function () {
        return require("private-next-pages/cms/journal/article/[editoSlug].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cms/journal/article/[editoSlug]"])
      });
    }
  